import React from 'react';
import { twMerge } from 'tailwind-merge';
type Variant = 'navy' | 'water' | 'outlineLight' | 'outline' | 'white';
interface ButtonLinkProps {
  href: string;
  children: React.ReactNode;
  variant?: Variant;
  className?: string;
  external?: boolean;
  ariaLabel?: string;
}
const variants: Record<Variant, string> = {
  navy: 'bg-navy text-white hover:bg-navy-600',
  water: 'bg-water text-navy-950 hover:bg-water-300',
  outlineLight: 'border border-white/60 text-white hover:bg-white hover:text-navy-900',
  outline: 'border border-navy/30 text-navy hover:border-navy hover:bg-navy hover:text-white',
  white: 'bg-white text-navy-900 hover:bg-sand'
};
export function ButtonLink({
  href,
  children,
  variant = 'navy',
  className,
  external,
  ariaLabel
}: ButtonLinkProps) {
  return <a href={href} aria-label={ariaLabel} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className={twMerge('inline-flex min-h-[48px] items-center justify-center gap-2 whitespace-nowrap rounded-md px-6 text-[15px] font-semibold transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-water focus-visible:ring-offset-2 active:scale-[0.98]', variants[variant], className)} data-id="element-35" data-mp="2hgzy5z62aa5v">
      {children}
    </a>;
}